/**
 * Allowed attachment types for Allo chat document attachments only.
 * Documents: PDF, Word, Excel, PowerPoint, TXT, MD, CSV, RTF.
 * Images: JPEG, PNG, WEBP.
 */

export const ALLOWED_DOCUMENT_ATTACHMENT_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.md,.csv,.rtf,image/jpeg,image/png,image/webp';

export const ALLOWED_DOCUMENT_ATTACHMENT_FORMATS_LABEL =
  'PDF, Word, Excel, PowerPoint, TXT, MD, CSV, RTF, JPG, PNG, WEBP';

/** Inline error message when user selects a disallowed file format. */
export const ALLOWED_DOCUMENT_ATTACHMENT_FORMAT_ERROR_MESSAGE =
  'This file format is not allowed. Use: .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .md, .csv, .rtf, .jpg, .png, .webp.';

const MIME = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/markdown',
  'text/csv',
  'application/csv',
  'text/rtf',
  'application/rtf',
  'image/jpeg',
  'image/png',
  'image/webp',
]);

const EXT = new Set([
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'txt',
  'md',
  'csv',
  'rtf',
  'jpg',
  'jpeg',
  'png',
  'webp',
]);

export function isAllowedDocumentAttachment(file: File): boolean {
  const mime = (file.type || '').toLowerCase();
  if (MIME.has(mime)) return true;
  const ext = file.name.split('.').pop()?.toLowerCase();
  return !!ext && EXT.has(ext);
}
